// extracted by extract-css-chunks-webpack-plugin
module.exports = {"cancel-order-button":"OrderStatusCancelOrderButton-0ad2301e561ae488","cancel-order-link":"OrderStatusCancelOrderButton-92f4ea58bb90a881"};